import BestMaPlansCTA from './BestMaPlansCTA';
import MedicareAdvocate from './medicareAdvocate';
import NewsletterSignup from './newsletterSignup';
import TalkToAnExpert from './talkToAnExpert';

// eslint-disable-next-line no-shadow
export enum CTAOptions {
  BEST_MA_PLANS = 'BEST_MA_PLANS',
  MEDICARE_ADVOCATE = 'MEDICARE_ADVOCATE',
  NEWSLETTER = 'NEWSLETTER',
  TALK_TO_AN_EXPERT = 'TALK_TO_AN_EXPERT',
}

export const OmniBox = ({ cta, phoneNumber = null }) => {
  switch (cta) {
    case CTAOptions.TALK_TO_AN_EXPERT:
      // NOT USING : Call phone number to talk to an expert
      return <TalkToAnExpert phoneNumber={phoneNumber} />;

    case CTAOptions.MEDICARE_ADVOCATE:
      // Ms State + City Pages
      return <MedicareAdvocate phoneNumber={phoneNumber} />;

    case CTAOptions.NEWSLETTER:
      // Articles
      // Sign up for FSM newsletter
      return <NewsletterSignup />;

    case CTAOptions.BEST_MA_PLANS:
      // Top Rated Medicare Advantage Pages
      return <BestMaPlansCTA phoneNumber={phoneNumber} />;

    default:
      return null;
  }
};
